import { useEffect } from 'react';

import { useAppSelector, useAppDispatch } from 'redux/store';
import { getAuthorizedZones } from '../../../../../../../redux/slices/lists/zonesSlice';
import { EditSelect } from 'components/forms/EditSelect';

interface ZonesProps {
  selectedValue: string;
  onChange: (value: string) => void;
  isEditMode: boolean;
}

const Zones = ({ selectedValue, onChange, isEditMode }: ZonesProps) => {
  const dispatch = useAppDispatch();
  const { zones } = useAppSelector((state) => state?.listOfZones);

  useEffect(() => {
    const fetchData = async () => {
      if (zones.length) return;
      try {
        const action = isEditMode ? 'update' : 'create';
        await dispatch(
          getAuthorizedZones({
            resourceType: 'node_definitions',
            action,
          }) as any
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [dispatch, isEditMode]);

  const sortedZones = [...(zones || [])].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="mb-2">
      <EditSelect
        label="Zone"
        value={selectedValue ?? ''}
        onChange={onChange}
        options={sortedZones.map((zone) => ({
          key: zone.name,
          value: zone.name,
          label: zone.name,
        }))}
      />
    </div>
  );
};

export default Zones;
